import React, { useEffect, useState } from 'react';

import { CF_CAPTCHA } from '../../constants';
import { STORAGE_KEY_CF_TOKEN } from '../../constants/storage';

import { LoadingComponent } from '../loading/LoadingComponent';

import './Captcha.scss';

const Captcha = () => {
    const [loaded, setLoaded] = useState(false);
    const [hideLoader, setHideLoader] = useState(false);
    const [widgetId, setWidgetId] = useState(null);

    useEffect(() => {
        const script = document.createElement('script');
        script.src =
            'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback';
        script.async = true;
        document.body.appendChild(script);
        setLoaded(true);

        return () => {
            setLoaded(false);
            setHideLoader(false);
            document.body.removeChild(script);
            window.turnstile.remove(widgetId);
        };
    }, []);

    useEffect(() => {
        if (loaded) {
            window.onloadTurnstileCallback = function() {
                setHideLoader(true);
                setWidgetId(
                    window.turnstile.render('#cf-captcha-container', {
                        sitekey: CF_CAPTCHA,
                        theme: 'light',
                        language: 'fr-fr',
                        size: window.innerWidth > 480 ? 'normal' : 'compact',
                        callback: function(token) {
                            sessionStorage.setItem(STORAGE_KEY_CF_TOKEN, token);
                        }
                    })
                );
            };
        }
    }, [loaded]);

    return <div id="cf-captcha-container">{!hideLoader && <LoadingComponent />}</div>;
};

export default Captcha;



// WEBPACK FOOTER //
// ./src/components/captcha/Captcha.js